import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {AuthProvider} from "../../providers/auth/auth";
import {PhotoLibrary} from "@ionic-native/photo-library";
import {ToastProvider} from "../../providers/toast/toast";

/**
 * Generated class for the LoginQrCodePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login-qr-code',
  templateUrl: 'login-qr-code.html',
})
export class LoginQrCodePage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private auth: AuthProvider,
    private photoLibrary: PhotoLibrary,
    private toast: ToastProvider
  ) {
  }

  ionViewDidLoad() {
  }

  create() {
    this.auth.createLoginToken().then(data => {
      this.auth.getWhoami();
    });
  }

  clear() {
    this.auth.clearLoginToken().then(data => {
      this.auth.getWhoami();
    });
  }

  getQrCodeImage() {
    const canvas = document.querySelector("canvas") as HTMLCanvasElement;
    return canvas.toDataURL("image/jpeg");
  }

  download() {
    this.photoLibrary.requestAuthorization({read: true, write: true}).then(() => {
      this.photoLibrary.saveImage(this.getQrCodeImage(), 'FocusOn').then(() => {
        this.toast.info('QR-Code wurde erfolgreich gespeichert.');
      }).catch(err => this.toast.error('Speichern in das Fotoalbum nicht möglich:' + err));
    })
      .catch(err => this.toast.error('Zugriff auf das Fotoalbum nicht möglich: ' + err));

  }
}



// WEBPACK FOOTER //
// ./src/pages/login-qr-code/login-qr-code.ts